module.exports = __webpack_public_path__ + "img/16.a24c2b6f.png";